import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { LANGUAGES } from "../lib/constants";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-switcher-trigger"
        className="flex items-center gap-2 rounded-none border border-white/15 bg-brand-black px-3 py-2 text-xs font-bold uppercase tracking-widest text-white hover:border-brand-orange hover:text-brand-orange"
      >
        <Globe className="h-4 w-4" />
        <span>{current.flag} {current.code.toUpperCase()}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="rounded-none border-white/20 bg-brand-black p-1 font-mono"
      >
        {LANGUAGES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className="flex cursor-pointer items-center gap-3 rounded-none px-3 py-2 text-sm uppercase tracking-wider text-white hover:bg-brand-orange hover:text-white"
          >
            <span className="text-base">{l.flag}</span>
            <span className="font-bold">{l.label}</span>
            <span className="ml-auto text-xs opacity-60">{l.code}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
